import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { useMediaQuery } from 'react-responsive';

export const useGetDrawerWidth = ({
    large,
    tablet,
    small,
    extraSmall,
    extraLarge
}: {
    large?: number | string;
    tablet?: number | string;
    small?: number | string;
    extraLarge?: number | string;
    extraSmall?: number | string;
} = {}) => {
    const theme = useInterstateTheme();
    const mediaQueries = {
        isExtraLargeSize: useMediaQuery({ query: `(min-width: ${theme.tokens.BaseScreenXxl})` }),
        isLargeSize: useMediaQuery({ query: `(min-width: ${theme.tokens.BaseScreenXl})` }),
        isSmallSize: useMediaQuery({ query: `(min-width: ${theme.tokens.BaseScreenMd})` }),
        isExtraSmallSize: useMediaQuery({ query: `(min-width: ${theme.tokens.BaseScreenSm})` }),
        isTabletSize: useMediaQuery({ query: `(min-width: ${theme.tokens.BaseScreenLg})` })
    };

    const defaultWidths = {
        extraLarge: '786px',
        large: '786px',
        tablet: '504px',
        small: '480px',
        extraSmall: '480px'
    };

    const formatWidth = (value: number | string | undefined, defaultValue: string): string => {
        if (value === undefined) return defaultValue;
        return typeof value === 'string' ? value : `${value}px`;
    };

    if (mediaQueries.isExtraLargeSize) return formatWidth(extraLarge, defaultWidths.extraLarge);
    if (mediaQueries.isLargeSize) return formatWidth(large, defaultWidths.large);
    if (mediaQueries.isTabletSize) return formatWidth(tablet, defaultWidths.tablet);
    if (mediaQueries.isSmallSize) return formatWidth(small, defaultWidths.small);
    if (mediaQueries.isExtraSmallSize) return formatWidth(extraSmall, defaultWidths.extraSmall);
    return defaultWidths.extraSmall;
};
